import { Grid, IconButton, IconButtonProps } from "@mui/material";
import PauseCircleFilledIcon from "@mui/icons-material/PauseCircleFilled";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import { observer } from "mobx-react";
import React from "react";
import SoundClipEditorStore from "../Stores/SoundClipEditorStore";
import PlaybackRate from "./PlaybackRate";
import Zoom from "./Zoom";

interface SoundClipVisualizerV2Props {
    viewModel: SoundClipEditorStore;
    enablePlaybackRate?: boolean;
    minimize?: boolean;
    enableZoom?: boolean;
    iconButton?: React.ReactNode;
    iconButtonProps?: Partial<IconButtonProps>;
}

export const MinimalPlayer: React.FC<SoundClipVisualizerV2Props> = observer(
    ({
        viewModel,
        enablePlaybackRate,
        minimize,
        enableZoom,
        iconButton,
        iconButtonProps = {},
    }) => {
        return (
            <Grid
                container
                item
                xs={3}
                sx={{
                    backgroundColor: "#FAFCFF",
                    minWidth: "70px",
                    maxWidth: "70px !important",
                    height: "84px",
                }}
            >
                <Grid
                    container
                    item
                    xs={12}
                    justifyContent="space-around"
                    style={{
                        marginLeft: enableZoom ? "10px" : "17.5px",
                    }}
                >
                    {iconButton && (
                        <Grid container item xs={6} justifyContent="center">
                            <IconButton
                                sx={{ color: "#3564D5" }}
                                {...iconButtonProps}
                                size="large"
                            >
                                {iconButton}
                            </IconButton>
                        </Grid>
                    )}
                    <Grid
                        container
                        item
                        xs={!!iconButton ? 6 : 12}
                        justifyContent="center"
                        height="45px"
                        paddingTop="6px"
                    >
                        <IconButton
                            onClick={viewModel.onPlayClick}
                            size="small"
                        >
                            {viewModel.isPlaying ? (
                                <PauseCircleFilledIcon
                                    fontSize={
                                        minimize || !!iconButton
                                            ? "small"
                                            : "large"
                                    }
                                    sx={{ color: "#3564D5" }}
                                />
                            ) : (
                                <PlayCircleFilledIcon
                                    fontSize={
                                        minimize || !!iconButton
                                            ? "small"
                                            : "large"
                                    }
                                    sx={{ color: "#3564D5" }}
                                />
                            )}
                        </IconButton>
                    </Grid>
                </Grid>
                <Grid
                    container
                    item
                    xs={12}
                    justifyContent="space-around"
                    style={{
                        marginLeft: enableZoom ? "10px" : "17.5px",
                    }}
                    paddingBottom="6px"
                >
                    {enablePlaybackRate && (
                        <Grid
                            item
                            xs={6}
                            container
                            justifyContent="space-around"
                        >
                            <PlaybackRate viewModel={viewModel} />
                        </Grid>
                    )}

                    {enableZoom && (
                        <Grid
                            item
                            display="flex"
                            borderRadius="0.25rem"
                            alignContent="center"
                            xs={6}
                        >
                            <Zoom viewModel={viewModel} minimal />
                        </Grid>
                    )}
                </Grid>
            </Grid>
        );
    },
);
